import { neverError } from '@seu-helpers';
import {
  SeuCanvasComponentItem,
  SeuCanvasStreamPositionItem,
  SeuCoords,
} from '@seu-types';

export function getStreamName(
  streamArray: SeuCanvasStreamPositionItem[],
  coords: SeuCoords | null,
  handleId: string | null,
  side: 'input' | 'output',
  handleIndex: number
): string | null {
  switch (side) {
    case 'output': {
      const outputStream = streamArray.find(
        (stream) =>
          stream.startX === coords?.x &&
          stream.startY === coords?.y &&
          ((handleId !== null &&
            stream.outputFromComponentHandleId === handleId) ||
            (stream.outputFromComponentHandleId === null && handleIndex === 0))
      );
      return outputStream ? outputStream.name : null;
    }
    case 'input': {
      const inputStream = streamArray.find(
        (stream) =>
          stream.endX === coords?.x &&
          stream.endY === coords?.y &&
          ((handleId !== null &&
            stream.inputForComponentHandleId === handleId) ||
            (stream.inputForComponentHandleId === null && handleIndex === 0))
      );
      return inputStream ? inputStream.name : null;
    }
    default:
      neverError(side);
  }
}

export function getComponentNameByStream(
  components: SeuCanvasComponentItem[],
  stream: SeuCanvasStreamPositionItem,
  side: 'input' | 'output'
): string {
  let id =
    side === 'input'
      ? stream.inputForComponentId
      : stream.outputFromComponentId;
  if (side === 'input' && stream.linkedToChimney) {
    id = '-1';
  } else if (side === 'output' && stream.inputStreamId) {
    id = stream.inputStreamId;
  }

  return components.find((component) => component.id === id)?.name ?? '???';
}
